
export const CHUC_NANG_PERMISSION_CODES = {
    // === QUẢN LÝ DỮ LIỆU CHUNG ===
    // Kho - Warehouse Management (6 chức năng)
    WEB_WAREHOUSE_LIST: 'WEB_WAREHOUSE_LIST',
    WEB_WAREHOUSE_DETAIL: 'WEB_WAREHOUSE_DETAIL',
    WEB_WAREHOUSE_ADD: 'WEB_WAREHOUSE_ADD',
    WEB_WAREHOUSE_EDIT: 'WEB_WAREHOUSE_EDIT',
    WEB_WAREHOUSE_DELETE: 'WEB_WAREHOUSE_DELETE',
    WEB_WAREHOUSE_EXPORT: 'WEB_WAREHOUSE_EXPORT',

    // Nhà cung cấp - Supplier Management (7 chức năng)
    WEB_SUPPLIER_LIST: 'WEB_SUPPLIER_LIST',
    WEB_SUPPLIER_DETAIL: 'WEB_SUPPLIER_DETAIL',
    WEB_SUPPLIER_ADD: 'WEB_SUPPLIER_ADD',
    WEB_SUPPLIER_EDIT: 'WEB_SUPPLIER_EDIT',
    WEB_SUPPLIER_DELETE: 'WEB_SUPPLIER_DELETE',
    WEB_SUPPLIER_IMPORT: 'WEB_SUPPLIER_IMPORT',
    WEB_SUPPLIER_EXPORT: 'WEB_SUPPLIER_EXPORT',

    // Hình thức vận chuyển - Transportation Management (7 chức năng)
    WEB_TRANSPORTATION_LIST: 'WEB_TRANSPORTATION_LIST',
    WEB_TRANSPORTATION_DETAIL: 'WEB_TRANSPORTATION_DETAIL',
    WEB_TRANSPORTATION_ADD: 'WEB_TRANSPORTATION_ADD',
    WEB_TRANSPORTATION_EDIT: 'WEB_TRANSPORTATION_EDIT',
    WEB_TRANSPORTATION_DELETE: 'WEB_TRANSPORTATION_DELETE',
    WEB_TRANSPORTATION_IMPORT: 'WEB_TRANSPORTATION_IMPORT',
    WEB_TRANSPORTATION_EXPORT: 'WEB_TRANSPORTATION_EXPORT',

    // Tỷ giá - Rate Management (4 chức năng)
    WEB_RATE_LIST: 'WEB_RATE_LIST',
    WEB_RATE_ADD: 'WEB_RATE_ADD',
    WEB_RATE_EDIT: 'WEB_RATE_EDIT',
    WEB_RATE_EXPORT: 'WEB_RATE_EXPORT',

    // Nhà cung cấp vận chuyển - Transport Provider Management (6 chức năng)
    WEB_TRANSPORT_PROVIDER_LIST: 'WEB_TRANSPORT_PROVIDER_LIST',
    WEB_TRANSPORT_PROVIDER_DETAIL: 'WEB_TRANSPORT_PROVIDER_DETAIL',
    WEB_TRANSPORT_PROVIDER_ADD: 'WEB_TRANSPORT_PROVIDER_ADD',
    WEB_TRANSPORT_PROVIDER_EDIT: 'WEB_TRANSPORT_PROVIDER_EDIT',
    WEB_TRANSPORT_PROVIDER_DELETE: 'WEB_TRANSPORT_PROVIDER_DELETE',
    WEB_TRANSPORT_PROVIDER_EXPORT: 'WEB_TRANSPORT_PROVIDER_EXPORT',

    // Nhà cung cấp thuế - Tax Provider Management (6 chức năng)
    WEB_TAX_PROVIDER_LIST: 'WEB_TAX_PROVIDER_LIST',
    WEB_TAX_PROVIDER_DETAIL: 'WEB_TAX_PROVIDER_DETAIL',
    WEB_TAX_PROVIDER_ADD: 'WEB_TAX_PROVIDER_ADD',
    WEB_TAX_PROVIDER_EDIT: 'WEB_TAX_PROVIDER_EDIT',
    WEB_TAX_PROVIDER_DELETE: 'WEB_TAX_PROVIDER_DELETE',
    WEB_TAX_PROVIDER_EXPORT: 'WEB_TAX_PROVIDER_EXPORT',

    // Nhà cung cấp tiền tệ - Currency Provider Management (6 chức năng)
    WEB_CURRENCY_PROVIDER_LIST: 'WEB_CURRENCY_PROVIDER_LIST',
    WEB_CURRENCY_PROVIDER_DETAIL: 'WEB_CURRENCY_PROVIDER_DETAIL',
    WEB_CURRENCY_PROVIDER_ADD: 'WEB_CURRENCY_PROVIDER_ADD',
    WEB_CURRENCY_PROVIDER_EDIT: 'WEB_CURRENCY_PROVIDER_EDIT',
    WEB_CURRENCY_PROVIDER_DELETE: 'WEB_CURRENCY_PROVIDER_DELETE',
    WEB_CURRENCY_PROVIDER_EXPORT: 'WEB_CURRENCY_PROVIDER_EXPORT',

    // === QUẢN LÝ SẢN PHẨM ===

    // Nhóm hàng - Category Management (7 chức năng)
    WEB_CATEGORY_LIST: 'WEB_CATEGORY_LIST',
    WEB_CATEGORY_DETAIL: 'WEB_CATEGORY_DETAIL',
    WEB_CATEGORY_ADD: 'WEB_CATEGORY_ADD',
    WEB_CATEGORY_EDIT: 'WEB_CATEGORY_EDIT',
    WEB_CATEGORY_DELETE: 'WEB_CATEGORY_DELETE',
    WEB_CATEGORY_IMPORT: 'WEB_CATEGORY_IMPORT',
    WEB_CATEGORY_EXPORT: 'WEB_CATEGORY_EXPORT',

    // Sản phẩm - Product Management (16 chức năng)
    WEB_PRODUCT_LIST: 'WEB_PRODUCT_LIST',
    WEB_PRODUCT_NCC_LIST: 'WEB_PRODUCT_NCC_LIST',
    WEB_PRODUCT_KHO_LIST: 'WEB_PRODUCT_KHO_LIST',
    WEB_PRODUCT_NCC_KHO_LIST: 'WEB_PRODUCT_NCC_KHO_LIST',
    WEB_PRODUCT_DETAIL: 'WEB_PRODUCT_DETAIL',
    WEB_PRODUCT_ADD: 'WEB_PRODUCT_ADD',
    WEB_PRODUCT_EDIT: 'WEB_PRODUCT_EDIT',
    WEB_PRODUCT_DELETE: 'WEB_PRODUCT_DELETE',
    WEB_PRODUCT_BULK_DELETE: 'WEB_PRODUCT_BULK_DELETE',
    WEB_PRODUCT_IMPORT: 'WEB_PRODUCT_IMPORT',
    WEB_PRODUCT_IMPORT_IMAGE: 'WEB_PRODUCT_IMPORT_IMAGE',
    WEB_PRODUCT_EXPORT: 'WEB_PRODUCT_EXPORT',
    WEB_PRODUCT_NCC_EXPORT: 'WEB_PRODUCT_NCC_EXPORT',
    WEB_PRODUCT_KHO_EXPORT: 'WEB_PRODUCT_KHO_EXPORT',
    WEB_PRODUCT_NCC_KHO_EXPORT: 'WEB_PRODUCT_NCC_KHO_EXPORT',
    WEB_PRODUCT_HISTORY_EDIT: 'WEB_PRODUCT_HISTORY_EDIT',
    WEB_PRODUCT_COMMON_ALL: 'WEB_PRODUCT_COMMON_ALL',

    // Nhóm công bố sản phẩm - Product Group Management (6 chức năng)
    WEB_PRODUCT_GROUP_LIST: 'WEB_PRODUCT_GROUP_LIST',
    WEB_PRODUCT_GROUP_DETAIL: 'WEB_PRODUCT_GROUP_DETAIL',
    WEB_PRODUCT_GROUP_ADD: 'WEB_PRODUCT_GROUP_ADD',
    WEB_PRODUCT_GROUP_EDIT: 'WEB_PRODUCT_GROUP_EDIT',
    WEB_PRODUCT_GROUP_DELETE: 'WEB_PRODUCT_GROUP_DELETE',
    WEB_PRODUCT_GROUP_EXPORT: 'WEB_PRODUCT_GROUP_EXPORT',

    // Nhóm giá - Price Category Management (6 chức năng)
    WEB_PRICE_CATEGORY_LIST: 'WEB_PRICE_CATEGORY_LIST',
    WEB_PRICE_CATEGORY_DETAIL: 'WEB_PRICE_CATEGORY_DETAIL',
    WEB_PRICE_CATEGORY_ADD: 'WEB_PRICE_CATEGORY_ADD',
    WEB_PRICE_CATEGORY_EDIT: 'WEB_PRICE_CATEGORY_EDIT',
    WEB_PRICE_CATEGORY_DELETE: 'WEB_PRICE_CATEGORY_DELETE',
    WEB_PRICE_CATEGORY_EXPORT: 'WEB_PRICE_CATEGORY_EXPORT',
    WEB_PRICE_CATEGORY_IMPORT: 'WEB_PRICE_CATEGORY_IMPORT',

    // === QUẢN LÝ ĐON HÀNG ===

    // Đơn hàng - Order Management (6 chức năng)
    WEB_ORDER_LIST: 'WEB_ORDER_LIST',
    WEB_ORDER_DETAIL: 'WEB_ORDER_DETAIL',
    WEB_ORDER_EXPORT: 'WEB_ORDER_EXPORT',
    WEB_ORDER_DETAIL_EXPORT: 'WEB_ORDER_DETAIL_EXPORT',
    WEB_ORDER_UPDATE_INFOR: 'WEB_ORDER_UPDATE_INFOR',
    WEB_ORDER_UPDATE_REALITY: 'WEB_ORDER_UPDATE_REALITY',
    WEB_ORDER_UPDATE_ADDITIONAL_INFOR_SHOW_ALL: 'WEB_ORDER_UPDATE_ADDITIONAL_INFOR_SHOW_ALL',
    WEB_ORDER_DETAIL_SHOW_ALL: 'WEB_ORDER_DETAIL_SHOW_ALL',

    // Container - Container Management (7 chức năng)
    WEB_CONTAINER_LIST: 'WEB_CONTAINER_LIST',
    WEB_CONTAINER_DETAIL: 'WEB_CONTAINER_DETAIL',
    WEB_CONTAINER_ADD: 'WEB_CONTAINER_ADD',
    WEB_CONTAINER_EDIT: 'WEB_CONTAINER_EDIT',
    WEB_CONTAINER_DELETE: 'WEB_CONTAINER_DELETE',
    WEB_CONTAINER_EXPORT: 'WEB_CONTAINER_EXPORT',
    WEB_CONTAINER_HISTORY_EDIT: 'WEB_CONTAINER_HISTORY_EDIT',
    WEB_CONTAINER_UPDATE_INFO: 'WEB_CONTAINER_UPDATE_INFO',
    WEB_CONTAINER_DETAIL_EXPORT: 'WEB_CONTAINER_DETAIL_EXPORT',
    WEB_CONTAINER_DETAIL_EXPORT_ALL_FIELDS: 'WEB_CONTAINER_DETAIL_EXPORT_ALL_FIELDS',
    // === QUẢN LÝ YÊU CẦU ===

    // Yêu cầu mua - Purchase Request Management (12 chức năng)
    WEB_PURCHASES_REQUEST_LIST: 'WEB_PURCHASES_REQUEST_LIST',
    WEB_PURCHASES_REQUEST_SHOW_ALL_LIST: 'WEB_PURCHASES_REQUEST_SHOW_ALL_LIST',
    WEB_PURCHASES_REQUEST_DETAIL: 'WEB_PURCHASES_REQUEST_DETAIL',
    WEB_PURCHASES_REQUEST_ADD: 'WEB_PURCHASES_REQUEST_ADD',
    WEB_PURCHASES_REQUEST_ADD_MULTI: 'WEB_PURCHASES_REQUEST_ADD_MULTI',
    WEB_PURCHASES_REQUEST_EDIT: 'WEB_PURCHASES_REQUEST_EDIT',
    WEB_PURCHASES_REQUEST_DELETE: 'WEB_PURCHASES_REQUEST_DELETE',
    WEB_PURCHASES_REQUEST_IMPORT: 'WEB_PURCHASES_REQUEST_IMPORT',
    WEB_PURCHASES_REQUEST_EXPORT: 'WEB_PURCHASES_REQUEST_EXPORT',
    WEB_PURCHASES_REQUEST_DETAIL_EXPORT: 'WEB_PURCHASES_REQUEST_DETAIL_EXPORT',
    WEB_PURCHASES_REQUEST_CONFIRM: 'WEB_PURCHASES_REQUEST_CONFIRM',
    WEB_PURCHASES_REQUEST_HISTORY_EDIT: 'WEB_PURCHASES_REQUEST_HISTORY_EDIT',
    WEB_PURCHASES_REQUEST_SHOW_ALL_PRICING: 'WEB_PURCHASES_REQUEST_SHOW_ALL_PRICING',
    WEB_PURCHASES_REQUEST_SHOW_ALL_HISTORY_ORDER: 'WEB_PURCHASES_REQUEST_SHOW_ALL_HISTORY_ORDER',

    // Yêu cầu tìm kiếm - Search Request Management (9 chức năng)
    WEB_SEARCH_REQUEST_LIST: 'WEB_SEARCH_REQUEST_LIST',
    WEB_SEARCH_REQUEST_DETAIL: 'WEB_SEARCH_REQUEST_DETAIL',
    WEB_SEARCH_REQUEST_ADD: 'WEB_SEARCH_REQUEST_ADD',
    WEB_SEARCH_REQUEST_ADD_MULTI: 'WEB_SEARCH_REQUEST_ADD_MULTI',
    WEB_SEARCH_REQUEST_EDIT: 'WEB_SEARCH_REQUEST_EDIT',
    WEB_SEARCH_REQUEST_DELETE: 'WEB_SEARCH_REQUEST_DELETE',
    WEB_SEARCH_REQUEST_IMPORT: 'WEB_SEARCH_REQUEST_IMPORT',
    WEB_SEARCH_REQUEST_EXPORT: 'WEB_SEARCH_REQUEST_EXPORT',
    WEB_SEARCH_REQUEST_CONFIRM: 'WEB_SEARCH_REQUEST_CONFIRM',
    WEB_SEARCH_REQUEST_HISTORY_EDIT: 'WEB_SEARCH_REQUEST_HISTORY_EDIT',

    // Yêu cầu tách - Request Share Management (6 chức năng)
    WEB_REQUEST_SHARE_LIST: 'WEB_REQUEST_SHARE_LIST',
    WEB_REQUEST_SHARE_DETAIL: 'WEB_REQUEST_SHARE_DETAIL',
    WEB_REQUEST_SHARE_ADD: 'WEB_REQUEST_SHARE_ADD',
    WEB_REQUEST_SHARE_EDIT: 'WEB_REQUEST_SHARE_EDIT',
    WEB_REQUEST_SHARE_DELETE: 'WEB_REQUEST_SHARE_DELETE',
    WEB_REQUEST_SHARE_EXPORT: 'WEB_REQUEST_SHARE_EXPORT',

    // === QUẢN LÝ BÁO GIÁ ===

    // Báo giá mua hàng - Purchase Pricing Management (8 chức năng)
    WEB_PRICING_LIST: 'WEB_PRICING_LIST',
    WEB_PRICING_ADD: 'WEB_PRICING_ADD',
    WEB_PRICING_EDIT: 'WEB_PRICING_EDIT',
    WEB_PRICING_DELETE: 'WEB_PRICING_DELETE',
    WEB_PRICING_DETAIL: 'WEB_PRICING_DETAIL',
    WEB_PRICING_EXPORT: 'WEB_PRICING_EXPORT',
    WEB_PRICING_DETAIL_EXPORT: 'WEB_PRICING_DETAIL_EXPORT',
    WEB_PRICING_HISTORY_EDIT: 'WEB_PRICING_HISTORY_EDIT',
    WEB_PRICING_DETAIL_SHOW_ALL: 'WEB_PRICING_DETAIL_SHOW_ALL',

    // Báo giá tìm hàng - Product Search Pricing Management (8 chức năng)
    WEB_PRODUCT_PRICING_LIST: 'WEB_PRODUCT_PRICING_LIST',
    WEB_PRODUCT_PRICING_ADD: 'WEB_PRODUCT_PRICING_ADD',
    WEB_PRODUCT_PRICING_ADD_MULTI: 'WEB_PRODUCT_PRICING_ADD_MULTI',
    WEB_PRODUCT_PRICING_EDIT: 'WEB_PRODUCT_PRICING_EDIT',
    WEB_PRODUCT_PRICING_DELETE: 'WEB_PRODUCT_PRICING_DELETE',
    WEB_PRODUCT_PRICING_DETAIL: 'WEB_PRODUCT_PRICING_DETAIL',
    WEB_PRODUCT_PRICING_EXPORT: 'WEB_PRODUCT_PRICING_EXPORT',
    WEB_PRODUCT_PRICING_DETAIL_EXPORT: 'WEB_PRODUCT_PRICING_DETAIL_EXPORT',
    WEB_PRODUCT_PRICING_HISTORY_EDIT: 'WEB_PRODUCT_PRICING_HISTORY_EDIT',

    // === QUẢN LÝ THANH TOÁN ===

    // Thanh toán - Payment Management (7 chức năng)
    WEB_PAYMENT_ORDER_LIST: 'WEB_PAYMENT_ORDER_LIST',
    WEB_PAYMENT_ORDER_DETAIL: 'WEB_PAYMENT_ORDER_DETAIL',
    WEB_PAYMENT_ORDER_ADD: 'WEB_PAYMENT_ORDER_ADD',
    WEB_PAYMENT_ORDER_EDIT: 'WEB_PAYMENT_ORDER_EDIT',
    WEB_PAYMENT_ORDER_DELETE: 'WEB_PAYMENT_ORDER_DELETE',
    WEB_PAYMENT_ORDER_EXPORT: 'WEB_PAYMENT_ORDER_EXPORT',
    WEB_PAYMENT_ORDER_HISTORY_EDIT: 'WEB_PAYMENT_ORDER_HISTORY_EDIT',

    // Yêu cầu thanh toán - Payment Request Management (6 chức năng)
    WEB_REQUEST_PAYMENT_LIST: 'WEB_REQUEST_PAYMENT_LIST',
    WEB_REQUEST_PAYMENT_DETAIL: 'WEB_REQUEST_PAYMENT_DETAIL',
    WEB_REQUEST_PAYMENT_ADD: 'WEB_REQUEST_PAYMENT_ADD',
    WEB_REQUEST_PAYMENT_EDIT: 'WEB_REQUEST_PAYMENT_EDIT',
    WEB_REQUEST_PAYMENT_DELETE: 'WEB_REQUEST_PAYMENT_DELETE',
    WEB_REQUEST_PAYMENT_EXPORT: 'WEB_REQUEST_PAYMENT_EXPORT',
    WEB_REQUEST_PAYMENT_HISTORY_EDIT: 'WEB_REQUEST_PAYMENT_HISTORY_EDIT',

    // Cân bằng công nợ - Balance of Debt Management (6 chức năng)
    WEB_BALANCEOFDEBT_LIST: 'WEB_BALANCEOFDEBT_LIST',
    WEB_BALANCEOFDEBT_DETAIL: 'WEB_BALANCEOFDEBT_DETAIL',
    WEB_BALANCEOFDEBT_ADD: 'WEB_BALANCEOFDEBT_ADD',
    WEB_BALANCEOFDEBT_EDIT: 'WEB_BALANCEOFDEBT_EDIT',
    WEB_BALANCEOFDEBT_DELETE: 'WEB_BALANCEOFDEBT_DELETE',
    WEB_BALANCEOFDEBT_EXPORT: 'WEB_BALANCEOFDEBT_EXPORT',
    WEB_BALANCEOFDEBT_HISTORY_EDIT: 'WEB_BALANCEOFDEBT_HISTORY_EDIT',

    // === QUẢN LÝ HỆ THỐNG ===

    // Người dùng - User Management (1 chức năng)
    WEB_USER_COMMON: 'WEB_USER_COMMON',
    WEB_SYNC_USER: 'WEB_SYNC_USER',

    WEB_THONGBAO_CANXACNHANBAOGIA: 'WEB_THONGBAO_CANXACNHANBAOGIA',
    WEB_THONGBAO_COTHAYDOIBAOGIA: 'WEB_THONGBAO_COTHAYDOIBAOGIA',
    WEB_THONGBAO_COYEUCAUMUA: 'WEB_THONGBAO_COYEUCAUMUA',
    WEB_THONGBAO_COYEUCAUTACH: 'WEB_THONGBAO_COYEUCAUTACH',
    WEB_THONGBAO_COYEUCAUTHANHTOAN: 'WEB_THONGBAO_COYEUCAUTHANHTOAN',
    WEB_THONGBAO_COYEUCAUTIM: 'WEB_THONGBAO_COYEUCAUTIM',
    WEB_THONGBAO_CANXACNHANDONTIM: 'WEB_THONGBAO_CANXACNHANDONTIM',
    WEB_THONGBAO_COTHAYDOIDONTIM: 'WEB_THONGBAO_COTHAYDOIDONTIM',

    // === CÔNG NỢ (menu mới — chốt kỳ) ===
    WEB_CONGNO_DATHANG_LIST: 'WEB_CONGNO_DATHANG_LIST',
    WEB_CONGNO_DATHANG_EXPORT: 'WEB_CONGNO_DATHANG_EXPORT',
    WEB_CONGNO_DATHANG_DETAIL: 'WEB_CONGNO_DATHANG_DETAIL',
    WEB_CONGNO_DATHANG_EXPORT_DETAIL: 'WEB_CONGNO_DATHANG_EXPORT_DETAIL',
    WEB_CONGNO_DATHANG_CHOT: 'WEB_CONGNO_DATHANG_CHOT',
    WEB_CONGNO_PHATHANG_LIST: 'WEB_CONGNO_PHATHANG_LIST',
    WEB_CONGNO_PHATHANG_EXPORT: 'WEB_CONGNO_PHATHANG_EXPORT',
    WEB_CONGNO_PHATHANG_DETAIL: 'WEB_CONGNO_PHATHANG_DETAIL',
    WEB_CONGNO_PHATHANG_EXPORT_DETAIL: 'WEB_CONGNO_PHATHANG_EXPORT_DETAIL',
    WEB_CONGNO_PHATHANG_CHOT: 'WEB_CONGNO_PHATHANG_CHOT',
    WEB_CONGNO_THUCTE_LIST: 'WEB_CONGNO_THUCTE_LIST',
    WEB_CONGNO_THUCTE_EXPORT: 'WEB_CONGNO_THUCTE_EXPORT',
    WEB_CONGNO_THUCTE_DETAIL: 'WEB_CONGNO_THUCTE_DETAIL',
    WEB_CONGNO_THUCTE_EXPORT_DETAIL: 'WEB_CONGNO_THUCTE_EXPORT_DETAIL',
    WEB_CONGNO_THUCTE_CHOT: 'WEB_CONGNO_THUCTE_CHOT',
    WEB_CONGNO_THUE_LIST: 'WEB_CONGNO_THUE_LIST',
    WEB_CONGNO_THUE_EXPORT: 'WEB_CONGNO_THUE_EXPORT',
    WEB_CONGNO_THUE_DETAIL: 'WEB_CONGNO_THUE_DETAIL',
    WEB_CONGNO_THUE_EXPORT_DETAIL: 'WEB_CONGNO_THUE_EXPORT_DETAIL',
    WEB_CONGNO_THUE_CHOT: 'WEB_CONGNO_THUE_CHOT',
    WEB_CONGNO_VANCHUYEN_LIST: 'WEB_CONGNO_VANCHUYEN_LIST',
    WEB_CONGNO_VANCHUYEN_EXPORT: 'WEB_CONGNO_VANCHUYEN_EXPORT',
    WEB_CONGNO_VANCHUYEN_DETAIL: 'WEB_CONGNO_VANCHUYEN_DETAIL',
    WEB_CONGNO_VANCHUYEN_EXPORT_DETAIL: 'WEB_CONGNO_VANCHUYEN_EXPORT_DETAIL',
    WEB_CONGNO_VANCHUYEN_CHOT: 'WEB_CONGNO_VANCHUYEN_CHOT',
    WEB_CONGNO_TIENTE_LIST: 'WEB_CONGNO_TIENTE_LIST',
    WEB_CONGNO_TIENTE_EXPORT: 'WEB_CONGNO_TIENTE_EXPORT',
    WEB_CONGNO_TIENTE_DETAIL: 'WEB_CONGNO_TIENTE_DETAIL',
    WEB_CONGNO_TIENTE_EXPORT_DETAIL: 'WEB_CONGNO_TIENTE_EXPORT_DETAIL',
    WEB_CONGNO_TIENTE_CHOT: 'WEB_CONGNO_TIENTE_CHOT',
    WEB_CONGNO_LICH_SU_CHOT_LIST: 'WEB_CONGNO_LICH_SU_CHOT_LIST',

    // === BÁO CÁO VÀ LỊCH SỬ ===

    // Báo cáo - Report Management (24 chức năng)
    WEB_REPORT_DATHANG_LIST: 'WEB_REPORT_DATHANG_LIST',
    WEB_REPORT_DATHANG_EXPORT: 'WEB_REPORT_DATHANG_EXPORT',
    WEB_REPORT_DATHANG_DETAIL: 'WEB_REPORT_DATHANG_DETAIL',
    WEB_REPORT_DATHANG_EXPORT_DETAIL: 'WEB_REPORT_DATHANG_EXPORT_DETAIL',
    WEB_REPORT_PHATHANG_LIST: 'WEB_REPORT_PHATHANG_LIST',
    WEB_REPORT_PHATHANG_EXPORT: 'WEB_REPORT_PHATHANG_EXPORT',
    WEB_REPORT_PHATHANG_DETAIL: 'WEB_REPORT_PHATHANG_DETAIL',
    WEB_REPORT_PHATHANG_EXPORT_DETAIL: 'WEB_REPORT_PHATHANG_EXPORT_DETAIL',
    WEB_REPORT_THUCTE_LIST: 'WEB_REPORT_THUCTE_LIST',
    WEB_REPORT_THUCTE_EXPORT: 'WEB_REPORT_THUCTE_EXPORT',
    WEB_REPORT_THUCTE_DETAIL: 'WEB_REPORT_THUCTE_DETAIL',
    WEB_REPORT_THUCTE_EXPORT_DETAIL: 'WEB_REPORT_THUCTE_EXPORT_DETAIL',
    WEB_REPORT_THUE_LIST: 'WEB_REPORT_THUE_LIST',
    WEB_REPORT_THUE_EXPORT: 'WEB_REPORT_THUE_EXPORT',
    WEB_REPORT_THUE_DETAIL: 'WEB_REPORT_THUE_DETAIL',
    WEB_REPORT_THUE_EXPORT_DETAIL: 'WEB_REPORT_THUE_EXPORT_DETAIL',
    WEB_REPORT_VANCHUYEN_LIST: 'WEB_REPORT_VANCHUYEN_LIST',
    WEB_REPORT_VANCHUYEN_EXPORT: 'WEB_REPORT_VANCHUYEN_EXPORT',
    WEB_REPORT_VANCHUYEN_DETAIL: 'WEB_REPORT_VANCHUYEN_DETAIL',
    WEB_REPORT_VANCHUYEN_EXPORT_DETAIL: 'WEB_REPORT_VANCHUYEN_EXPORT_DETAIL',
    WEB_REPORT_TIENTE_LIST: 'WEB_REPORT_TIENTE_LIST',
    WEB_REPORT_TIENTE_EXPORT: 'WEB_REPORT_TIENTE_EXPORT',
    WEB_REPORT_TIENTE_DETAIL: 'WEB_REPORT_TIENTE_DETAIL',
    WEB_REPORT_TIENTE_EXPORT_DETAIL: 'WEB_REPORT_TIENTE_EXPORT_DETAIL',

    // Lịch sử đơn hàng - Order History Management (4 chức năng)
    WEB_HISTORY_ORDER_LIST: 'WEB_HISTORY_ORDER_LIST',
    WEB_HISTORY_ORDER_EXPORT: 'WEB_HISTORY_ORDER_EXPORT',
    WEB_HISTORY_ORDER_DETAIL_EXPORT: 'WEB_HISTORY_ORDER_DETAIL_EXPORT',
    WEB_HISTORY_ORDER_TAO_PHIEU_NHAN: 'WEB_HISTORY_ORDER_TAO_PHIEU_NHAN',
    WEB_HISTORY_REALITY_LIST: 'WEB_HISTORY_REALITY_LIST',
    WEB_HISTORY_REALITY_EXPORT: 'WEB_HISTORY_REALITY_EXPORT',
    WEB_HISTORY_REALITY_SHOW_ALL_LIST: 'WEB_HISTORY_REALITY_SHOW_ALL_LIST',
    WEB_HISTORY_ORDER_DELETED_LIST: 'WEB_HISTORY_ORDER_DELETED_LIST',

    // Lịch sử hoạt động (nhật ký thao tác người dùng)
    WEB_LICH_SU_HOAT_DONG_LIST: 'WEB_LICH_SU_HOAT_DONG_LIST',
    WEB_LICH_SU_HOAT_DONG_ALL: 'WEB_LICH_SU_HOAT_DONG_ALL',

    // Lịch sử tìm hàng - Search History Management (4 chức năng)
    WEB_HISTORY_SEARCH_LIST: 'WEB_HISTORY_SEARCH_LIST',
    WEB_HISTORY_SEARCH_EXPORT: 'WEB_HISTORY_SEARCH_EXPORT',
    WEB_HISTORY_SEARCH_SHOW_ALL: 'WEB_HISTORY_SEARCH_SHOW_ALL',

    // Mã vận đơn - Bill of Lading Code Management (6 chức năng)
    WEB_BILLOFLADINGCODE_LIST: 'WEB_BILLOFLADINGCODE_LIST',
    WEB_BILLOFLADINGCODE_ADD: 'WEB_BILLOFLADINGCODE_ADD',
    WEB_BILLOFLADINGCODE_EDIT: 'WEB_BILLOFLADINGCODE_EDIT',
    WEB_BILLOFLADINGCODE_DELETE: 'WEB_BILLOFLADINGCODE_DELETE',
    WEB_BILLOFLADINGCODE_IMPORT: 'WEB_BILLOFLADINGCODE_IMPORT',
    WEB_BILLOFLADINGCODE_EXPORT: 'WEB_BILLOFLADINGCODE_EXPORT',

} as const
